import React, { useState } from 'react';

import { IBypassDedupConfig } from '~/src/dash/api/console-api';
import { EBool } from '~/src/dash/api/types/bool';
import { PillSwitcherV2 } from '~/src/dash/components/tabs/PillSwitcherV2';
import {
  borderRadius,
  ButtonV2,
  Col,
  Cols,
  fontSizing,
  Row,
  Rows,
  spacing,
  Text,
  TextInput,
} from '~/src/dash/publicaUI';
import DeleteIcon from '@material-ui/icons/Delete';
import { publicaColors } from '~/src/dash/utils/colors';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';

interface ICaretUpDownProps {
  isExpanded: boolean;
}

const CaretUpDown: React.FC<ICaretUpDownProps> = ({ isExpanded }) => {
  return isExpanded ? (
    <KeyboardArrowUpIcon fontSize='small' />
  ) : (
    <KeyboardArrowDownIcon fontSize='small' />
  );
};

interface IAdomainAllowListProps {
  index: number;
  BypassDedupConfig: IBypassDedupConfig[]; // Replace with the actual type for BypassDedupConfig
  toggleBypassAdomainExactMatchActive: (index: number) => void;
  addAdomainUserEntry: (index: number, adomainEntry: string, config: IBypassDedupConfig[]) => void;
  expandAdomainAllowList: (index: number) => void;
  handleAdomainDelete: (index: number, adomainIdx: number) => void;
}

export const AdomainAllowList: React.FC<IAdomainAllowListProps> = ({
  index,
  BypassDedupConfig,
  toggleBypassAdomainExactMatchActive,
  addAdomainUserEntry,
  expandAdomainAllowList,
  handleAdomainDelete,
}) => {
  const config = BypassDedupConfig;
  const [adomainEntry, setAdomainEntry] = useState('');

  const options = [
    {
      key: 'exact_match',
      value: EBool.toBoolString(EBool.EBool_TRUE),
      label: 'Exact Match',
      isSelected: EBool.isTrue(config[index].IsAdomainExactMatch),
      isDisabled: false,
    },
    {
      key: 'contains',
      value: EBool.toBoolString(EBool.EBool_FALSE),
      label: 'Contains',
      isSelected: !EBool.isTrue(config[index].IsAdomainExactMatch),
      isDisabled: false,
    },
  ];

  return (
    <Rows noVerticalPadding horizontalPadding paddingBottom={spacing.base}>
      <Row noVerticalPadding>
        <Cols
          gap={spacing.small}
          style={{ alignItems: 'center', cursor: 'pointer' }}
          onClick={() => expandAdomainAllowList(index)}
        >
          <Col>
            <Text small>{`Allowed Adomains (${config[index].Adomain.length})`}</Text>
          </Col>
          <Col displayFlex>
            <CaretUpDown isExpanded={EBool.isTrue(config[index].IsBypassAdomainFieldsOpen)} />
          </Col>
        </Cols>
      </Row>
      {EBool.isTrue(config[index].IsBypassAdomainFieldsOpen) && (
        <Row noPadding>
          <Rows noHorizontalPadding>
            <Row noHorizontalPadding>
              <Cols paddingLeft={spacing.base}>
                <Col style={{ marginRight: spacing.small }}>
                  <PillSwitcherV2
                    size='small'
                    options={options}
                    onChange={() => toggleBypassAdomainExactMatchActive(index)}
                  />
                </Col>
                <Col>
                  <Text
                    bold
                    extraSmall
                    style={{
                      borderRadius: borderRadius.small,
                      background: publicaColors.veryLightBlue,
                      paddingLeft: spacing.small,
                      paddingRight: spacing.small,
                    }}
                  >
                    {EBool.isTrue(config[index].IsAdomainExactMatch)
                      ? 'Adomains will first be checked for an exact match. If the given adomain is plainly formatted, it will be checked against variations of the URL (i.e. getpublica.com matches with https://getpublica.com, www.getpublica.com/, etc.).'
                      : 'With “contains,” please add keywords (i.e. publica matches with https://getpublica.com, ttps://getpublica.fr, www.getpublica.com/, etc.)'}
                  </Text>
                </Col>
              </Cols>
            </Row>
            <Row noVerticalPadding>
              <Cols>
                <Col paddingTop={spacing.extraSmall} paddingRight={spacing.small}>
                  <TextInput
                    handleOnChange={(text: string) => setAdomainEntry(text)}
                    placeholder={
                      !EBool.isTrue(config[index].IsAdomainExactMatch) ? 'ex: nike' : 'ex: nike.com'
                    }
                    width='240px'
                  />
                </Col>
                <Col>
                  <ButtonV2
                    style={{ color: publicaColors.blue, fontSize: fontSizing.small }}
                    onClick={() => addAdomainUserEntry(index, adomainEntry, config)}
                    clearBackground
                  >
                    + ADD
                  </ButtonV2>
                </Col>
              </Cols>
            </Row>
            <Row largeVerticalPadding>
              <div style={{ width: '450px' }}>
                {' '}
                <TableContainer component={Paper}>
                  <Table size={'small'}>
                    <TableHead>
                      <TableRow>
                        {/* TABLE HEADERS*/}
                        <TableCell>Adomain</TableCell>
                        <TableCell>Delete</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {/* TABLE CONTENT*/}
                      {
                        // for each list element
                        config[index].Adomain.map((adomain: string, adomainIdx: number) => (
                          <TableRow>
                            {/* TITLE*/}
                            <TableCell>{adomain}</TableCell>

                            {/* DELETE BUTTON*/}
                            <TableCell>
                              <IconButton
                                onClick={() => handleAdomainDelete(index, adomainIdx)}
                                style={{ height: '25px', width: '25px' }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))
                      }
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </Row>
          </Rows>
        </Row>
      )}
    </Rows>
  );
};
